import React, { useMemo, useCallback } from 'react';

import { Link, makeStyles, Typography } from '@material-ui/core';

import Resource from '../../models/Resource';
import EditFields from '../common/EditFields';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      marginBottom: '32px',
      marginTop: '32px',
    },
    fieldsContainer: {
      marginBottom: '0px',
      marginTop: '0px',
    },
    selectionModeContainer: {
      marginTop: '32px',
    },
  };
});

const SelfHelpCategorySelection = ({ dataRef, categoryList, onCategoryChange, currentCategory, categorySelectionMode, onCategorySelectionModeChange }) => {
  const classes = useStyles();

  const handleCategoryChange = useCallback(
    (category) => {
      if (onCategoryChange) onCategoryChange(category);
    },
    [onCategoryChange]
  );

  const handleCreteNewCategory = useCallback(() => {
    if (onCategorySelectionModeChange) onCategorySelectionModeChange('text');
  }, [onCategorySelectionModeChange]);

  const handleSelectFromList = useCallback(() => {
    if (onCategorySelectionModeChange) onCategorySelectionModeChange('list');
  }, [onCategorySelectionModeChange]);

  const categoryFields = useMemo(() => {
    if (!categoryList?.length || categorySelectionMode === 'text') {
      return [
        {
          className: 'm-0',
          name: 'selfHelpCategoryName',
          onChange: (value) => handleCategoryChange(value),
          required: true,
          type: 'text',
        },
      ];
    }

    const managedCategoryList = (categoryList || []).map((category) => {
      return {
        label: category.name,
        value: category.name,
      };
    });

    return [
      {
        className: 'm-0',
        items: managedCategoryList,
        label: 'Self Help Category',
        name: 'selfHelpCategoryName',
        onChange: (value) => handleCategoryChange(value.selfHelpCategoryName),
        required: true,
        type: 'select',
      },
    ];
  }, [handleCategoryChange, categoryList, categorySelectionMode]);

  const defaultDataValue = useMemo(() => {
    if (currentCategory) {
      return {
        selfHelpCategoryName: currentCategory,
      };
    }

    if (!categoryList?.length) return undefined;

    if (categorySelectionMode === 'list') {
      return {
        selfHelpCategoryName: categoryList[0].name,
      };
    }

    return undefined;
  }, [categoryList, categorySelectionMode, currentCategory]);

  return (
    <div className={classes.container}>
      <Typography align="left" className="field-label">
        Self Help Category
      </Typography>
      <EditFields useLabel={false} ref={dataRef} fields={categoryFields} data={defaultDataValue} labelPosition="top" useAutoFocus={false} validate={Resource.validateCreate} />

      {!!categoryList?.length && (
        <div className={classes.selectionModeContainer}>
          <Typography variant="body2">
            {categorySelectionMode === 'list' ? 'You can select a category from the list above, or ' : 'Type the new self help category, or '}
            {categorySelectionMode === 'list' && (
              <Link component="button" variant="body2" onClick={handleCreteNewCategory}>
                Create a new category
              </Link>
            )}
            {categorySelectionMode === 'text' && (
              <Link component="button" variant="body2" onClick={handleSelectFromList}>
                Select a category
              </Link>
            )}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default SelfHelpCategorySelection;
